import React, { useEffect, useRef, useState } from 'react'
import HeaderUser from '../components/homePage/HeaderUser'
import FooterPage from '../components/homePage/FooterPage'
import InboxLeftSideBar from '../components/inbox/InboxLeftSideBar'
import { useSelector } from 'react-redux';
import { ageCalculate, checkIncomeShowHide, decimalToFeetInches, nameMask } from '../utils/utils'
import { Link } from 'react-router-dom';
import ConfirmPopup from '../components/homePage/ConfirmPopup';
import Cookies from "js-cookie";
import { annualIncomeMap } from '../utils/Helper';

function InboxDeclined() {
    const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
    const [pageTitle, setPageTitle] = useState("");
    const { userDetailLogin } = useSelector((state) => state.auth);
    const [meneberList, setMemberList] = useState([]);
    const modalConfirmRef = useRef(null)
    const modalInstanceConfirm = useRef(null);
    const [popupMessage, setPopupMessage] = useState("")
    const [partnerValueId, setPartnerValueId] = useState("")
    const [memberValueId, setMemberValueId] = useState("")
    const [memberValueStatus, setMemberValueStatus] = useState("")
    const [showButton, setShowButton] = useState(1)
    const endpoint = window.location.pathname.split("/").filter(Boolean).pop();

    const [planDetailUser, setPlanDetailUser] = useState({})
    const [totalUserSentInterest, setTotalUserSentInterest] = useState(0)
    const [expiryDate, setExpiryDate] = useState(false)
    const [totalUserView, setTotalUserView] = useState(0)
    const [blurPhoto, setBlurPhoto] = useState(0)

    const title = {
        sent: "Request Sent",
        accepted: "Accepted",
        received: "Received",
        decline: "Decline"
    };

    // list fetch
    const listMember = async (pageType) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/inbox-sent-decline`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    pageType: pageType,
                    //member_id: userDetailLogin._id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMemberList(data.data);
            } else {
                console.error("Error fetching members:", data.error || data.message);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    };


    //cancel request
    const cancelRequestButton = async (partnerId) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/cancel-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    member_id: userDetailLogin._id,
                    partner_id: partnerId,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setPartnerValueId("")
                setMemberList((prevList) =>
                    prevList.filter((member) => member?.partner_id?._id !== partnerId)
                );
                //console.log("Cancel successful:", data);
            } else {
                console.error("Error fetching members:", data.error || data.message);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    }
    const cancelRequest = async (partnerId) => {
        //console.log(partnerId)
        setPartnerValueId(partnerId)
        setShowButton(1)
        setPopupMessage('are you sure you want to cancel request?')
        modalInstanceConfirm.current?.show();
    };


    useEffect(() => {
        const newTitle = title[endpoint] || "Inbox";
        setPageTitle(newTitle);
        listMember(endpoint);

        document.title = newTitle;
    }, [endpoint]);


    useEffect(() => {
        // Initialize Bootstrap modal once (after first render)
        const modalConfirmEl = document.getElementById("confirmPopupId");
        if (modalConfirmEl) {
            modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
        }


    }, []);

    const yesNoButton = (value) => {

        //console.log('confirm', value)
        if (value === 'Yes') {
            //console.log('yes', partnerValueId)
            cancelRequestButton(partnerValueId)
        }
        modalInstanceConfirm.current?.hide();
    }

    const changeStatusRequestButton = async (id, status) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/status-change`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    id: id,
                    status: status,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMemberValueId("")
                setMemberValueStatus("")
                setMemberList((prevList) =>
                    prevList.filter((member) => member?._id !== id)
                );
                //console.log("Change request successful:", data);
            } else {
                console.error("Error fetching request:", data.error || data.message);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    }

    const changeStatus = (id, status) => {
        if (status === 'Accepted') {

            changeStatusRequestButton(id, status)
        } else {
            setMemberValueId(id)
            setMemberValueStatus(status)
            setPopupMessage('are you sure you want to decline request?')
            setShowButton(2)
            modalInstanceConfirm.current?.show();
        }

    }

    const yesNoStatusButton = (value) => {


        if (value === 'Yes') {
            //console.log('yes', partnerValueId)
            changeStatusRequestButton(memberValueId, memberValueStatus)
        }
        modalInstanceConfirm.current?.hide();
    }


    const fetchUserDetailMatch = async (userId) => {

        const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        });

        const data = await res.json();
        //console.log(data)
        if (data.status) {

            //console.log('interest', data.data[0])
            const isExpired = new Date(data.data[0].plan_detail?.expiry_date) < new Date();

            setExpiryDate(isExpired)
            setTotalUserSentInterest(data.data[0].interest_user)
            setPlanDetailUser(data.data[0].plan_detail)
            setTotalUserView(data.data[0].total_user_view)


            //let blurPhoto = 0 
            if (!data.data[0]?.plan_detail || Object.keys(data.data[0]?.plan_detail).length === 0 || data.data[0]?.plan_detail?.plan_id?.name === 'Basic' || (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' && data.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (data.data[0]?.plan_detail?.plan_id?.name === 'Premium' && data.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (expiryDate && (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' || data.data[0]?.plan_detail?.plan_id?.name === 'Premium'))) {
                //console.log('blur photo')
                //blurPhoto = 1
                setBlurPhoto(1)
            }


        }

    }


    useEffect(() => {

        if (userDetailLogin?._id) {
            fetchUserDetailMatch(userDetailLogin?._id)
        }

    }, [userDetailLogin])


    return (
        <>

            <ConfirmPopup ref={modalConfirmRef} message={popupMessage} yesNoButton={showButton === 2 ? yesNoStatusButton : yesNoButton} />


            {meneberList && meneberList.length > 0 ? (
                meneberList.map((member, index) => {

                    let profilePhoto;
                    if (member?.partner_id.profile_photo === 1) {
                        profilePhoto = member?.partner_id.photo
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo_blur
                        }
                    } else if (member?.partner_id.profile_photo === 2) {
                        profilePhoto = member?.partner_id.photo1
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo1_blur
                        }
                    } else if (member?.partner_id.profile_photo === 3) {
                        profilePhoto = member?.partner_id.photo2
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo2_blur
                        }
                    } else if (member?.partner_id.profile_photo === 4) {
                        profilePhoto = member?.partner_id.photo3
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo3_blur
                        }
                    } else if (member?.partner_id.profile_photo === 5) {
                        profilePhoto = member?.partner_id.photo4
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo4_blur
                        }
                    } else {
                        profilePhoto = member?.partner_id.photo
                        if (blurPhoto === 1) {
                            profilePhoto = member?.partner_id.photo_blur
                        }
                    }

                    return (
                        <>
                            <div className="col-12 mb-4" key={member._id || index} >
                                <div className="res-profiles inboxcont">
                                    <div className="row">
                                        <div className="col-12 padi-res">
                                            <div className="row">
                                                <div className="col-lg-8 col-md-9  ic-ver-res">
                                                    <ul>
                                                        <li>

                                                            <h4>
                                                                <Link to={`/profile-details/${member?.partner_id?._id}`}>
                                                                    {member?.partner_id?.name}
                                                                </Link>
                                                            </h4>
                                                        </li>
                                                        <li>
                                                            <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/verified.png`} alt="" />
                                                        </li>
                                                        <li className="profil-id-re">( ID :&nbsp;{member?.partner_id?.profile_id} )</li>
                                                    </ul>
                                                </div>
                                                <div className="col-lg-4 col-md-3 res-fl   ">
                                                    <ul className="justify-content-lg-end">
                                                        <li>
                                                            <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/calender.png`} alt="" />
                                                        </li>
                                                        <li className=""> {new Date(member.createdAt).toLocaleDateString("en-GB", {
                                                            day: "2-digit",
                                                            month: "short"
                                                        })}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 pad-res-2">
                                            <div className="row">
                                                <div className="col-lg-3 col-md-4">
                                                    <div className='inboximg'>
                                                        <Link to={`/profile-details/${member?.partner_id?._id}`}>
                                                            <img src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : 'assets/img/no-image.jpg'} alt="" />
                                                        </Link>

                                                    </div>
                                                </div>
                                                <div className="col-lg-9 col-md-8 col-xs-12">
                                                    <div className="row">
                                                        <div className="col-xl-5 col-lg-12">
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Age / Height</span>:
                                                                {(member?.partner_id?.dob || member?.partner_id?.height)
                                                                    ? `${member?.partner_id?.dob ? ageCalculate(member?.partner_id?.dob) : ""}${member?.partner_id?.dob && member?.partner_id?.height ? ", " : ""}${member?.partner_id?.height ? decimalToFeetInches(member?.partner_id.height) : ""}`
                                                                    : ""}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Religion</span>: {member?.partner_id?.religion?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Cast</span>: {member?.partner_id?.caste?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Gotra</span>: {member?.partner_id?.gotra?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Occupation</span>:
                                                                {member?.partner_id?.occupation?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Location</span>:
                                                                {[member?.partner_id?.loc_state?.name, member?.partner_id?.loc_city?.name].filter(Boolean).join(", ")}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-12">
                                                            <div className="profiledata-rowss marg-to d-flex align-items-start">
                                                                <span className="fieldname">Education</span>:
                                                                {member.partner_id?.highest_degree?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Manglik</span>: {member?.partner_id?.manglik}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Marital Status</span>
                                                                :  {member?.partner_id?.marital_status?.name}
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Income</span>:
                                                                {
                                                                    checkIncomeShowHide(
                                                                        member?.partner_id?.profileSettings?.income_show,
                                                                        planDetailUser
                                                                    )
                                                                        ? member?.partner_id?.annual_income
                                                                            ? annualIncomeMap(member.partner_id.annual_income)
                                                                            : ""
                                                                        : member?.partner_id?.annual_income
                                                                            ? nameMask(member.partner_id.annual_income)
                                                                            : ""
                                                                }
                                                            </div>
                                                            <div className="profiledata-rowss d-flex align-items-start">
                                                                <span className="fieldname">Job</span>: {member?.partner_id?.working_with?.name}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <p className="invit-res">
                                                        <Link to="#" style={{ cursor: 'default' }}>
                                                            {member?.partner_id?.gender === 'Male' ? 'He' : 'She'} declined your invitation, This member cannot be contacted.
                                                        </Link>
                                                    </p>



                                                </div>
                                                <div className="col-lg-4 col-xs-12 col-md-6 col-xl-3">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </>
                    )


                })
            ) : (
                <div className="profilelist-box d-md-flex align-items-md-start justify-content-md-start mb-2">
                    No member found
                </div>
            )}



        </>
    )
}

export default InboxDeclined
